module.exports = __webpack_public_path__ + "static/HOME_PARTNERS-AMAZON-WANCLOUDS.79b4ffe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HOME_PARTNERS-AMAZON-WANCLOUDS.png
// module id = 513
// module chunks = 35783957827783